// Workspace Supabase passthrough config — thin wrapper around the
// SDK-owned helpers. Frontend code goes through `sdk.execute(entity, op,
// args)` and never sees the wrapper URL or the Supabase-vs-Mongo split.
// URL composition and the REST/realtime split live in
// `@symbo.ls/sdk/services/supabasePassthrough`.

import {
  createSupabasePassthroughConfig,
  workspaceProjectEdgeFunctionUrl,
  governanceSessionAccessToken as _sdkGovernanceSessionAccessToken
} from '@symbo.ls/sdk'
import {
  SUPABASE_URL as _RAW_SUPABASE_URL,
  SUPABASE_KEY,
  SUPABASE_ANON_KEY,
  getSupabase
} from './supabaseClient.js'
import { workspaceApiBase } from './workspaceApiBase.js'

export const RAW_SUPABASE_URL = _RAW_SUPABASE_URL
export const SUPABASE_URL = `${workspaceApiBase()}/workspace-project/sb`
export { SUPABASE_KEY, SUPABASE_ANON_KEY }

export const edgeFunctionUrl = (name) => workspaceProjectEdgeFunctionUrl(workspaceApiBase(), name)
export const edgeFunctionHeaders = () => ({ Authorization: `Bearer ${SUPABASE_ANON_KEY}` })

// Single source of truth for the federated governance JWT used by the
// workspace-project token provider (the wrapper extracts `workspace_id`
// from this JWT to scope RLS).
export const governanceSessionAccessToken = () =>
  _sdkGovernanceSessionAccessToken(_RAW_SUPABASE_URL)

export const restHeaders = () => {
  const token = governanceSessionAccessToken() || SUPABASE_ANON_KEY
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${token}`
  }
}

// Pass `apiBase` as a function so a runtime channel flip
// (`localStorage.symbols_api_channel = 'localNext'`) takes effect on
// every new createClient call without reloading.
export const supabaseFetchConfig = createSupabasePassthroughConfig({
  apiBase: workspaceApiBase,
  rawSupabaseUrl: _RAW_SUPABASE_URL,
  anonKey: SUPABASE_ANON_KEY,
  getRealtimeClient: () => {
    if (typeof window === 'undefined') return null
    try { return getSupabase() } catch (_) { return null }
  }
})

// Sync getter — ticket page onCreate synchronously registers a realtime
// channel; async callers should prefer `getRealtimeSupabase()` from
// `@symbo.ls/sdk-bridge` directly.
export const getSupabaseRealtimeClient = () => {
  if (typeof window === 'undefined') return null
  try { return getSupabase() } catch (_) { return null }
}
